import {ValidatedField} from "src/pages/AdminPage/AddAndUpdateSaas/dialogs/sharedFields/ValidatedField";
import {SecretField} from "src/pages/AdminPage/AddAndUpdateSaas/dialogs/sharedFields/SecretField";
import {isValidEmailAddress} from "src/pages/AdminPage/AddAndUpdateSaas/dialogs/sharedFields/validationFunctions";
import {DtxSpacer} from "src/components/common/DtxSpacer";

export const EmailAndPassword = () => {
  return <>
    <ValidatedField
      validationFunction={isValidEmailAddress}
      valueKey="email"
      errorLabel="valid email required"
    />
    <DtxSpacer space={2} />
    <SecretField
      valueKey="password"
    />
  </>;
};
